import type { QualityCheckRow, QualityDimension, QualityVerdict } from "@/types";

export const DIMENSIONS: ReadonlyArray<{ key: QualityDimension; label: string; definition: string }> = [
  {
    key: "substance",
    label: "Substance",
    definition:
      "AI interviews only. How much usable material the conversation yielded: developed answers, concrete details, engagement with follow-up questions.",
  },
  {
    key: "consistency",
    label: "Consistency",
    definition:
      "Whether the answers are intelligible and coherent: flags gibberish, off-topic answers and flagrant contradictions between answers.",
  },
  {
    key: "authenticity",
    label: "Authenticity",
    definition:
      "Whether the respondent wrote their answers themselves: flags identical text pasted across several questions and machine-generated content.",
  },
  {
    key: "appropriateness",
    label: "Appropriateness",
    definition:
      "Whether anything should be kept from the client's eyes: insults, threats or obscene content. Harsh but honest feedback is not penalized.",
  },
];

// Mirrored in api/app/controllers/api/quality_checks_controller.rb and mcp/src/episto/quality.ts.
export const VERDICT_LABEL: Record<QualityVerdict, string> = { green: "OK", orange: "Review", red: "NOK" };

export type FinalVerdict = "ok" | "nok";

export const FINAL_LABEL: Record<FinalVerdict, string> = { ok: "OK", nok: "NOK" };

export const verdictVariant = (verdict: QualityVerdict): "success" | "warning" | "destructive" =>
  verdict === "green" ? "success" : verdict === "orange" ? "warning" : "destructive";

export const scoreVariant = (score: number): "success" | "warning" | "destructive" =>
  score <= 2 ? "destructive" : score === 3 ? "warning" : "success";

export const finalFor = (row: QualityCheckRow): FinalVerdict => {
  if (row.is_valid_quality_manual !== null) return row.is_valid_quality_manual ? "ok" : "nok";
  return row.quality?.verdict === "red" ? "nok" : "ok";
};

export const lastFour = (token: string | null): string => (token ? token.slice(-4) : "");
